import React, { useContext } from 'react';
import Categories from './categories';
import { GlobalUiContext } from '~/context/globalUiContext';
import { getLoginUrl } from '~/helpers/url';
import { getRegisterUrl } from '../helpers/url';

const Menu = () => {
  const { hamburgerOpened } = useContext(GlobalUiContext);

  return (
    <aside className={`col-lg-3 col-xl-2_5 sidebar ${hamburgerOpened ? 'open' : ''}`}>
      <div className="action-element">
        <a href={getLoginUrl()} className="action-element__element">
          Sign in
        </a>
        <a href={getRegisterUrl()} className="btn btn-primary action-element__element">
          Sign up
        </a>
      </div>
      <Categories />
    </aside>
  );
};

export default Menu;
